import { Navigate } from '@sorare/routing';

import {
  ANY_SPORT_MY_CARDS_CARDS,
  ANY_SPORT_MY_CARDS_COLLECTIONS,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { LIFECYCLE, useLifecycle } from '@sorare/core/src/hooks/useLifecycle';

const MyCardsPage = () => {
  const { lifecycle } = useLifecycle();
  const { generateSportContextPath, sport } = useSportContext();

  const lastVisitedTab = lifecycle?.[LIFECYCLE.lastVisitedMyCardsTab]?.[sport];
  const tabToVisit =
    lastVisitedTab === 'myCards'
      ? ANY_SPORT_MY_CARDS_CARDS
      : ANY_SPORT_MY_CARDS_COLLECTIONS;

  return (
    <Navigate
      replace
      to={generateSportContextPath(tabToVisit)}
      keepSearchParams
    />
  );
};

export default MyCardsPage;
